import { Stack, Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';
import dayjs from 'dayjs';
import { DayOffType } from 'src/type/day-off-config';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  onUpdate: (id: string) => void;
  onDelete: (id: string) => void;
  data: DayOffType | undefined;
  clearSelectedData: VoidFunction;
};

export default function DayOffViewDialog({
  open,
  onClose,
  onUpdate,
  onDelete,
  data,
  clearSelectedData,
}: Props) {
  const getInfo = () => {
    if (!data) return [];

    const { date, startTime, endTime, note, createdByUser, updatedByUser, createdAt, updatedAt } =
      data;

    return [
      { label: 'วันที่', value: dayjs(date).format('DD MMMM BBBB') },
      { label: 'เวลาเริ่ม', value: dayjs(startTime, 'HH:mm:ss').format('HH:mm น.') },
      { label: 'เวลาสิ้นสุด', value: dayjs(endTime, 'HH:mm:ss').format('HH:mm น.') },
      { label: 'วันที่สร้างรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      {
        label: 'ผู้สร้างรายการ',
        value: `${createdByUser.firstName} ${createdByUser.lastName}` || '-',
      },
      { label: 'วันที่แก้ไขล่าสุด', value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.') },
      {
        label: 'ผู้แก้ไขล่าสุด',
        value: `${updatedByUser.firstName} ${updatedByUser.lastName}` || '-',
      },
      { label: 'หมายเหตุ', value: note || '-' },
    ];
  };

  const handleUpdate = () => {
    if (data?.id) {
      onUpdate(data?.id);
    }
  };

  const handleDelete = () => {
    if (data?.id) {
      onDelete(data.id);
    }
  };

  const handleClose = () => {
    onClose();
    clearSelectedData();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>รายละเอียดวันปิดทำการ</DialogTitle>

      <DialogContent>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Stack direction="row" justifyContent="space-between" width={1}>
          <Button variant="outlined" onClick={handleDelete}>
            ลบ
          </Button>
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" onClick={handleUpdate}>
              แก้ไข
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              ปิด
            </Button>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
